module.exports = __webpack_public_path__ + "img/lead-time.e8151db9.png";